export const noKnownDrugAllergiesNemsis = '8801013'
export const isAnyNoKnowDrugAllergySelected = (savedValues: any) =>
  savedValues.some((allergyObj: any) => allergyObj.nemsisCode === noKnownDrugAllergiesNemsis)
export const getDisabledAllergyList = (savedValues: any, currentOption: any) => {
  const isMedicationAllergySelected = savedValues.some(
    (allergyObj: any) => allergyObj.allergyType === null || allergyObj.allergyType === 'medication'
  )
  if (isAnyNoKnowDrugAllergySelected(savedValues)) {
    return (
      (currentOption.nemsisCode !== noKnownDrugAllergiesNemsis && currentOption.allergyType === null) ||
      currentOption.allergyType === 'medication' ||
      (currentOption.nemsisCode === noKnownDrugAllergiesNemsis &&
        savedValues.find((allergyObj: any) => allergyObj.nemsisCode === noKnownDrugAllergiesNemsis)?.id !==
          currentOption.id)
    )
  }
  if (isMedicationAllergySelected) {
    return currentOption.nemsisCode === noKnownDrugAllergiesNemsis
  }
  return false
}
